import Entity from './Entity.js'
import Vector from '../Vector.js'
import Size from '../Size.js'

class Wall extends Entity {
    
    constructor(id, size, position) {
        super();
        this.id = id;
        this.size = size;
        this.position = position;
    }
    
    getId() {
        return this.id
    }
    
    setSize(size) {
        this.size = size;
        return this;
    }
    
    
    tick() {
        super.tick()
    }
    
    draw(ctx) {
        super.draw(ctx)
        const position = this.getPosition();
        const size = this.getSize();
        ctx.fillRect(position.getX(), position.getY(), size.getWidth(), size.getHeight());
    }
    
}

export default Wall
